import React, { Component } from 'react'
import { ButtonToolbar, Row, Col, Modal, DropdownButton, MenuItem, ButtonGroup, Button } from 'react-bootstrap'

import HSGStudentGrid from './HSGStudentGrid/HSGStudentGrid'
import Pagination from '../../HSGPagination/HSGPagination'

const ailmentFilterMap = {
    'Obese': 'obese',
    'Under Weight': 'underweight',
    'Normal': 'normal',
    'Over Weight': 'overweight',
    'Vision Normal': 'vision_normal',
    'Vision Abnormal': 'vision_abnormal'
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

class Student extends Component {
    constructor(props) {
        super(props)
        this.state = {
            studentArr: [],
            selectedClass: null,
            selectedSection: null,
            selectedAilment: null,
            inSearchString: ''
        }
    }

    componentWillMount() {
        if (this.props.organizationId) {
            this.props.getSchoolClasses(this.props.organizationId)
            this.props.fetchCustomStudentList(Object.assign({}, this.props.studentHeader, { orgId: this.props.organizationId, 
                inOffset: 0, 
                inSearchString: '', 
                inLimit: 10,
                class: '',
                section: '',
                sortField:"firstname",
                sortBy:"asc",
                inOffset: 0
            }))
        }

    }


    componentWillReceiveProps(nextProps) {
        if(this.props.organizationId !== nextProps.organizationId) {
            this.props.getSchoolClasses(this.props.organizationId)
            this.props.fetchCustomStudentList(Object.assign({}, this.props.studentHeader, { orgId: nextProps.organizationId, 
                inOffset: 0, 
                inSearchString: '', 
                inLimit: 10,
                class: '',
                section: '',
                sortField:"firstname",
                sortBy:"asc",
                inOffset: 0
            }))
        } 

        if(this.props.dataUpdateFlag !== nextProps.dataUpdateFlag) {
            this.props.fetchCustomStudentList(nextProps.studentHeader, true)
        }
    }

    search(param) {
        let studentHeader = Object.assign({}, this.props.studentHeader)
        studentHeader.inSearchString = param;
        studentHeader.inOffset = 0;
        this.props.fetchCustomStudentList(studentHeader)
    }

    searchStudent = (e) => {
        const {inSearchString} = this.state
        e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase())
    }

    updateSearchBox = e => {
        e.target.value !== this.state.inSearchString && this.setState({ inSearchString: e.target.value})
    }

    toolbar = () => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='search-box-container'>
                    <input onChange={(e) =>  {this.updateSearchBox(e)}} 
                        onKeyDown={e=>{this.searchStudent(e)}} placeholder="Type in Student Name , Admission Number or HSG-ID.." className="input-search-box" type='text' 
                        value={this.state.inSearchString} />
                </div>
            </div>
        );
    }

    showNext = where => {
        let { inLimit, inOffset } = this.props.studentHeader
        let { totalStudent, studentHeader } = this.props
        if (where === 'prev') {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit
            this.props.fetchCustomStudentList(Object.assign({}, studentHeader, { inOffset: newOffset, inLimit: 10 }))
        } else {
            if (inOffset >= totalStudent || (inOffset + inLimit) >= totalStudent) {
                return
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchCustomStudentList(Object.assign({}, studentHeader, { inOffset: newOffset, inLimit: 10 }))
        }
    }

    fetchNewFilteredList = (flag) => {
        const { selectedClass, selectedSection, selectedAilment } = this.state

        const config = {
            class: flag && selectedClass ? selectedClass : null,
            section: flag && selectedSection ? selectedSection : null,
            ailment: flag && selectedAilment ? selectedAilment : null,
            orgId: this.props.organizationId ? this.props.organizationId : null,
            inOffset: 0
        }

        this.props.fetchCustomStudentList(Object.assign({}, this.props.studentHeader, config))
    }

    addNewFilter = (val, field) => {
        const newFilter = {
            [field]: val
        }
        this.setState({ ...newFilter }, () => this.fetchNewFilteredList(true))
    }

    resetFilter = () => {
        //window.location.reload()
        this.setState({
            selectedClass: null,
            selectedSection: null,
            selectedAilment: null
        }, () => this.fetchNewFilteredList(false))
    }

    getClasses = (classes, selectedClass, ailment, isSmall) => {
        return !isSmall ? [
            <button key={'reset'} className="btn hsg-btn-warning right" onClick={() => this.resetFilter()}>
                Reset
            </button>,
            <div className="right" key={'section'} >
                <DropdownButton title={this.state.selectedSection || "Section"} id='dropdown-for-section' onSelect={data => this.addNewFilter(data, 'selectedSection')}>
                    {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ?
                        classes[selectedClass].map(section => this.state.selectedSection === section ? <MenuItem key={section} eventKey={section} active>{section}</MenuItem> : <MenuItem key={section} eventKey={section}>{section}</MenuItem>)
                        : <MenuItem>{'Please select a class'}</MenuItem>}
                </DropdownButton>
            </div>,
            <div className="right" key={'classes'}>
                <DropdownButton title={this.state.selectedClass || "Class"} id='dropdown-for-class' className="right" onSelect={data => this.addNewFilter(data, 'selectedClass')}>
                    {Object.keys(classes).map(eachClass => this.state.selectedClass === eachClass ? <MenuItem key={eachClass} eventKey={eachClass} active>{eachClass}</MenuItem> : <MenuItem key={eachClass} eventKey={eachClass}>{eachClass}</MenuItem>)}
                </DropdownButton>
            </div>,
            <div className="right" key={'ailment'}>
                <DropdownButton title={this.state.selectedAilment && getKeyByValue(ailmentFilterMap ,this.state.selectedAilment) || "Ailment"} id='dropdown-for-class' className="right" onSelect={data => this.addNewFilter(ailmentFilterMap[data], 'selectedAilment')}>
                    {Object.keys(ailment).map(eachAilment => this.state.selectedAilment === eachAilment ? <MenuItem key={eachAilment} eventKey={eachAilment} active>{eachAilment}</MenuItem> : <MenuItem key={eachAilment} eventKey={eachAilment}>{eachAilment}</MenuItem>)}
                </DropdownButton>
            </div>
        ] : (
            <ButtonGroup className='hsg-toolbar'>
                <DropdownButton title={this.state.selectedClass || "Class"} id='dropdown-for-class' onSelect={data => this.addNewFilter(data, 'selectedClass')}>
                    {Object.keys(classes).map(eachClass => this.state.selectedClass === eachClass ? <MenuItem key={eachClass} eventKey={eachClass} active>{eachClass}</MenuItem> : <MenuItem key={eachClass} eventKey={eachClass}>{eachClass}</MenuItem>)}
                </DropdownButton>
                <DropdownButton title={this.state.selectedSection || "Section"} id='dropdown-for-section' onSelect={data => this.addNewFilter(data, 'selectedSection')}>
                    {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ?
                        classes[selectedClass].map(section => this.state.selectedSection === section ? <MenuItem key={section} eventKey={section} active>{section}</MenuItem> : <MenuItem key={section} eventKey={section}>{section}</MenuItem>)
                        : <MenuItem>{'Please select a class'}</MenuItem>}
                </DropdownButton>
                <Button bsStyle="btn hsg-btn-warning-small left" onClick={() => this.resetFilter()}>
                    Reset
                </Button>
            </ButtonGroup>
        )
    }

    getToolbarItems = () => {
        return window.innerWidth > 767 ? (
            <ButtonToolbar className ='hsg-toolbar'>
                <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.handleDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                    Download All Reports
                </button>
                <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.handleCBSEDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                    Download CBSE Reports
                </button> 
                <button className="btn hsg-btn-consltNow hsg-btn-primary" onClick={() => this.viewReport()}>
                    View CBSE Reports
                </button>
                {this.getClasses(this.props.classes, this.state.selectedClass, this.ailmentFilterMap)}
            </ButtonToolbar>
        ) : (
            <ButtonToolbar className ='hsg-toolbar'>
                <ButtonGroup>
                    <Button bsStyle="btn hsg-btn-warning-small" onClick={() => this.handleDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                        Download All Reports
                    </Button>
                    {/* <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.switchConfirmationModal(true)}>
                        Download All Reports
                    </button> 
                    <Button bsStyle="btn hsg-btn-primary-small" onClick={() => this.viewReport()}>
                        View All Reports
                    </Button>*/}
                </ButtonGroup>
                {this.getClasses(this.props.classes, this.state.selectedClass, this.ailmentFilterMap, true)}
            </ButtonToolbar>
        )
    }

    _renderPagination = (className) => {

        const {studentHeader, studentList, totalStudent} = this.props
        // pagination component can be shared if you want same UI for your component
        // you need to provide this component with fetched data, total data and className
        // if you need to show this on top or bottom that can be arranged with className
        // inOffset to tell what data is being shown
        // the view will be something like this...
        // (                        1-5 of 123 < >                 )


        return (
            studentList ? 
            <Pagination
                inOffset={studentHeader.inOffset}
                showNext={this.showNext}
                data={studentList}
                total={totalStudent}
                className={className}
            /> :
            null
        )
    }

    /*showNext = where => {

        const {totalStudent} = this.state

        let { inLimit, inOffset } = this.props.studentHeader
        
        if (where === 'prev') {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit
            if (inOffset !== newOffset) {
                this.props.fetchCustomStudentList(Object.assign( {}, this.props.studentHeader, { inOffset: newOffset } ))
            }
        } else {
            if (inOffset >= totalStudent || (inOffset + inLimit) >= totalStudent) {
                return
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchCustomStudentList(Object.assign( {}, this.props.studentHeader, { inOffset: newOffset } ))
        }
    }*/


    createPDF() {

        //let htm = this.render()

        //let options = {
         // html: '<h1>PDF TEST</h1>',
         // fileName: 'test',
         // directory: 'Documents',
        //};
    
        //let file = RNHTMLtoPDF.convert(options)
        // console.log(file.filePath);
        //alert(file.filePath);
    }
    

    render() {

        const {studentList, totalStudent, studentHeader} = this.props

        return (
            <div>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: 10, paddingRight: 30, marginBottom: 20}}>
                    {this.getClasses(this.props.classes, this.state.selectedClass, ailmentFilterMap)}
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: 10, marginBottom: 10}}>
                    {this.toolbar()}
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: 20}}>
                    {this._renderPagination("hsg-dashboard-pagination right")}
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12">
                    {
                        <HSGStudentGrid
                            studentList = {studentList}
                            studentTotal = {totalStudent}
                            offset = {studentHeader.offset}
                            addStudentMedicalInfo = {(uuid, custom) => this.props.addStudentMedicalInfo(uuid, custom)}
                            postStudentEpisodeInfo = {(studentId, customJson, episodeType) => this.props.postStudentEpisodeInfo(studentId, customJson, episodeType)}
                            userProfile = {this.props.userProfile}
                            fetchCustomStudentList = {() => this.props.fetchCustomStudentList(studentHeader)}
                            userRole= {this.props.userRole}
                        />
                    }
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: 20}}>
                    {this._renderPagination("hsg-dashboard-pagination-bottom right")}
                </div>

            </div>
        )
    }

}

export default Student


// WEBPACK FOOTER //
// ./src/Containers/StudentCustomContainer/Component/Student.js